import { useDispatch } from 'react-redux'
import { UseAppDispatch } from 'store/types'

// useDispatch только для любого типа (можно делать с асинхронными акшинами)
export const useThunkDispatch: UseAppDispatch = useDispatch as UseAppDispatch
